export default __webpack_public_path__ + "static/media/GAMA-500-MISTRAL.740591cc.pdf";